import { render, staticRenderFns } from "./UserIcon.vue?vue&type=template&id=24b2c5c8&"
import script from "./UserIcon.vue?vue&type=script&lang=ts&"
export * from "./UserIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports